import { OrderbookGrouping } from '@drift/common';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import Select from 'src/components/primitives/Select/Select';
import { cj } from 'src/utils/classNames';

interface Props {
	options: {
		value: OrderbookGrouping;
		label: string;
	}[];
	value: number;
	onChange: (val: number) => void;
	isLoading: boolean;
}

export const OrderbookGroupSizeSelector = ({
	options,
	value,
	onChange,
	isLoading,
}: Props) => {
	const {
		value: selectedValue,
		open,
		onOpenChange,
		onValueChange,
		selectedOption,
		selectOptions,
	} = useSelect({
		options,
		onSelectedValueChange: onChange,
		selectedValue: value,
	});

	return (
		<Select.Root
			open={open}
			onOpenChange={onOpenChange}
			value={selectedValue}
			onValueChange={onValueChange}
		>
			<Select.Trigger
				disabled={isLoading}
				className="border-0 bg-transparent p-0 hover:bg-transparent"
				valueClassName={cj(
					'typo-t4 transition-colors hover:text-text-secondary',
					isLoading && 'opacity-0'
				)}
			>
				{selectedOption?.label}
			</Select.Trigger>
			<Select.Options>
				{selectOptions.map((option) => (
					<Select.Option key={option.value} value={option.value}>
						{option.label}
					</Select.Option>
				))}
			</Select.Options>
		</Select.Root>
	);
};
